// src/components/Friends.js
import React, { useState, useEffect, useContext } from 'react';
import MyNavbar from '../components/MyNavbar';
import Imgprofile from '../assets/images/Profile.png';
import { db, auth } from '../firebase'; // Import firebase and auth
import { collection, getDocs, query, where, orderBy, limit } from 'firebase/firestore';
import { AuthContext } from '../context/AuthProvider';

const Friends = () => {
  const { user } = useContext(AuthContext); // Get the logged-in user
  const [friendsPosts, setFriendsPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch friends' posts from Firestore
    const fetchFriendsPosts = async () => {
      if (!user) return; // If no user is logged in, return
      
      try {
        // Fetch the user's friends list
        const userRef = collection(db, 'users');
        const userDoc = await getDocs(query(userRef, where('uid', '==', user.uid))); // Get the logged-in user
        const userSnapshot = userDoc.docs[0];
        
        if (userSnapshot) {
          const friendsList = userSnapshot.data().friends; // Get the friends' userIds from the `friends` array

          // Now fetch the posts by those friends
          const postsRef = collection(db, 'posts');
          const postsQuery = query(
            postsRef,
            where('uid', 'in', friendsList), // Filter by friends' userIds
            orderBy('timestamp', 'desc'), // Order posts by the most recent
            limit(10) // Limit to 10 posts for now
          );
          const postsSnapshot = await getDocs(postsQuery);

          const postsData = postsSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
          }));

          setFriendsPosts(postsData);
        }
      } catch (err) {
        setError('Error fetching posts');
      } finally {
        setLoading(false);
      }
    };

    fetchFriendsPosts();
  }, [user]); // Run effect when user changes

  if (loading) {
    return <div>Loading posts...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <>
      <MyNavbar />
      <div className="container">
        <div className="row justify-content-center pt-5">
          {friendsPosts.length === 0 ? (
            <p>No posts from your friends yet.</p>
          ) : (
            friendsPosts.map(post => (
              <div key={post.id} className="col-10 col-md-8 card py-3 mt-5">
                <div className="d-flex justify-content-between">
                  <div className="d-flex">
                    <img
                      src={Imgprofile}
                      alt="Profile"
                      style={{ width: '80px', height: '80px' }}
                      className="rounded-circle me-3 mt-1"
                    />
                    <div className="mt-3">
                      <div className="d-flex">
                        <h5>{post.username}</h5>
                        <h3
                          style={{
                            width: '5px',
                            height: '5px',
                            alignSelf: 'center',
                          }}
                          className="mx-2 rounded-circle bg-secondary"
                        />
                        <h6>Friend</h6>
                      </div>
                      <small className="text-secondary">
                        {new Date(post.timestamp.seconds * 1000).toLocaleString()}
                      </small>
                    </div>
                  </div>
                  <div>
                    <a>Options</a>
                  </div>
                </div>
                <hr />
                <div className="p-3">
                  <p>
                    {post.content}
                    <button className="border-0 px-1 rounded">Read More</button>
                  </p>
                </div>
                <hr />
                <div className="d-flex justify-content-around mx-5">
                  <div className="d-flex justify-content-center">
                    <i>Like</i>
                  </div>
                  <div className="d-flex justify-content-center">
                    <i>Comment</i>
                  </div>
                  <div className="d-flex justify-content-center">
                    <i>Save</i>
                  </div>
                  <div className="d-flex justify-content-center">
                    <i>Share</i>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  header: {
    backgroundColor: '#282c34',
    padding: '20px',
    color: 'white',
    textAlign: 'center',
  },
  main: {
    flex: '1',
    padding: '20px',
    textAlign: 'center',
  },
  footer: {
    backgroundColor: '#282c34',
    padding: '10px',
    color: 'white',
    textAlign: 'center',
  },
};

export default Friends;
